import React from 'react';

import styled from 'styled-components';
import { ReactComponent as CrossIcon } from '../assets/img/icons/cross.svg';

const LoginWrapper = styled.div`
  margin: 0px;
  padding: 0px 60px;
  border-radius: 30px;
  background-color: #fff;
  display: block;
  width: 100%;
  position: relative;
  @media all and (max-width: 1439px) {
    padding: 0px 40px;
    border-radius: 21px;
    max-width: 380px;
  }
  .cross-btn {
    position: absolute;
    right: 16px;
    top: 18px;
    cursor: pointer;
    @media all and (max-width: 1439px), all and (max-height: 749px) {
      top: 12px;
      svg {
        width: 23px;
        height: 23px;
      }
    }
  }
  h2 {
    color: #424b50;
    font-size: 54px;
    line-height: 50px;
    margin: 130px 0 10px 0;
    font-weight: 400;
    text-align: left;
    font-family: "Roboto Slab";
    font-weight: 900;
    @media all and (max-width: 1439px), all and (max-height: 749px) {
      font-size: 38px;
      margin: 95px 0 0 0;
      line-height: 45px;
    }
  }
  p {
    font-family: "Roboto";
    font-size: 16px;
    color: #5e7079;
    margin: 30px 0;
    @media all and (max-width: 1439px), all and (max-height: 749px) {
      font-size: 12px;
      margin: 20px 0;
    }
  }
  ul {
    margin: 0px 0 85px 0;
    padding: 0px;
    li {
      color: #5e7079;
      font-size: 18px;
      font-weight: 500;
      list-style-position: outside;
      padding-left: 10px;
      margin-left: 20px;
      margin-bottom: 20px;
      font-family: "Roboto";
      @media all and (max-width: 1439px), all and (max-height: 749px) {
        font-size: 13px;
        padding-left: 5px;
      }
      a {
        color: #1EC252;
      }
    }
  }
`;

interface Props {
  setRedirectPath: (url: string) => void;
}

const ForgotUsername: React.FC<Props> = function ForgotUsername(props: Props) {
  const { setRedirectPath } = props;
  const SUPPORT_EMAIL = 'mailto:support@xiqinc.com?subject=Retrieve My Username/Email Address';

  return (
    <LoginWrapper>
      <span
        className="cross-btn"
        onClick={() => setRedirectPath('')}
        onKeyPress={() => setRedirectPath('')}
        role="button"
        aria-label="Close"
        tabIndex={0}
      >
        <CrossIcon />
      </span>
      <h2>ok, let’s get you back in</h2>
      <p>
        While we can’t help you retrieve your email address directly, you do
        have some options:
      </p>
      <ul>
        <li>
          Reach out to the account owner at your organization to retrieve your
          username
        </li>
        <li>
          Send us an email
          <a href={SUPPORT_EMAIL}> here</a>
          , and our support team will help
          you get back in
        </li>
      </ul>
    </LoginWrapper>
  );
};

export default ForgotUsername;
